<template>
  <div class="content_box">
    <div class="industryCode" id="ManageTable">
      <div class="industryCode_header">
        <div class="industryCode_logo">
          <img
            style="width: 29px; height: 29px"
            src="@/assets/imgs/icon/region_classify.png"
            alt
          />
        </div>
        <h3>报表统计</h3>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="按地区" name="regionClassify"></el-tab-pane>
        <el-tab-pane label="按报表" name="reportClassify"></el-tab-pane>
        <el-tab-pane label="按行业" name="industryClassify"></el-tab-pane>
        <el-tab-pane
          label="按企业注册类型"
          name="cnterpriseClassify"
        ></el-tab-pane>
      </el-tabs>
      <div
        style="
          border-bottom: 1px solid rgba(155, 155, 155, 0.25);
          margin-bottom: 20px;
        "
      >
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <!-- <el-form-item label="地区">
                    <el-select v-model="formInline.region" placeholder="请选择">
                        <el-option :key="item.code"
                                   :label="item.name"
                                   :value="item.code" v-for="item in seatList"></el-option>
                    </el-select>
        </el-form-item>-->
          <el-form-item label="填报周期">
            <el-select v-model="formInline.report_cycle" placeholder="请选择">
              <el-option label="月报" value="0"></el-option>
              <el-option label="季报" value="1"></el-option>
              <el-option label="半年报" value="2"></el-option>
              <el-option label="年报" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="填报期">
            <el-date-picker
              format="yyyy-MM"
              value-format="yyyy-MM"
              :clearable="false"
              v-model="formInline.date_range"
              type="month"
              placeholder="选择填报期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit"
              class="bg5584FF formBotton"
              >查询</el-button
            >
            <el-button type="info" @click="reset" class="formBotton"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-link style="margin-bottom: 20px" type="primary" @click="exportData">{{
        exportLabel
      }}</el-link>
      <el-table
        border
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
        v-loading="loading"
      >
        <el-table-column
          align="center"
          :label="`${tableDate}报表报送情况`"
          center
        >
          <el-table-column prop="name" label="报表名称"></el-table-column>
          <el-table-column prop="cycle" label="报表周期"></el-table-column>
          <el-table-column prop="obj" label="填报对象"></el-table-column>
          <el-table-column prop="count" label="应填表数"></el-table-column>
          <el-table-column prop="ysbCount" label="已上报数"></el-table-column>
          <el-table-column prop="wsbCount" label="未上报数">
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'notReport')">{{
                scope.row.wsbCount
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="wshCount" label="未审核数">
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'unaudited')">{{
                scope.row.wshCount
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shbtgCount" label="审核未通过数">
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'notPass')">{{
                scope.row.shbtgCount
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="shtgCount" label="审核通过数">
            <template slot-scope="scope">
              <span class="detail" @click="toDetail(scope.row, 'pass')">{{
                scope.row.shtgCount
              }}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-dialog
        title="信息一览"
        v-if="showDialogVisible"
        :visible.sync="showDialogVisible"
        :close-on-click-modal="false"
        class="titleChange"
        width="80%"
      >
        <el-tabs v-model="activeNames">
          <el-tab-pane label="未上报" name="notReport">
            <notReport
              v-if="activeNames == 'notReport'"
              :method="method"
              :report_cycle="report_cycle"
              :region="region"
              :date_range="date_range"
            ></notReport>
          </el-tab-pane>
          <el-tab-pane label="未审核" name="unaudited">
            <unaudited
              v-if="activeNames == 'unaudited'"
              :method="method"
              :report_cycle="report_cycle"
              :region="region"
              :date_range="date_range"
            ></unaudited>
          </el-tab-pane>
          <el-tab-pane label="审核未通过" name="notPass">
            <notPass
              v-if="activeNames == 'notPass'"
              :method="method"
              :report_cycle="report_cycle"
              :region="region"
              :date_range="date_range"
            ></notPass>
          </el-tab-pane>
          <el-tab-pane label="审核通过" name="pass">
            <pass
              v-if="activeNames == 'pass'"
              :method="method"
              :report_cycle="report_cycle"
              :region="region"
              :date_range="date_range"
            ></pass>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import notReport from "../../ReportExamine/notReport/index";
import unaudited from "../../ReportExamine/unaudited/index";
import notPass from "../../ReportExamine/notPass/index";
import pass from "../../ReportExamine/pass/index";
import { export2Excel } from "@/utils/utils";
import { mapGetters } from "vuex";

export default {
  components: {
    unaudited,
    notPass,
    pass,
    notReport,
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaLists",
    }),
  },
  data() {
    return {
      activeName: "reportClassify",
      activeNames: "notReport",
      tableSelectData: [],
      tableData: [],
      currentPage: 1,
      currentPages: 1,
      loading: false,
      date_range: "",
      region: "",
      method: "noRole",
      formInline: {
        //查询对象
        report_cycle: "",
        date_range: "",
        region: "",
      },
      exportLabel: "<<点击此处可导出报表",
      regionTree: [],
      rules: {
        //表单验证规则
        reason: [{ required: true, message: "请输入意见", trigger: "blur" }],
      },
      tableDate: "",
      passForm: {},
      passLoading: false,
      showObj: {},
      selectLoading: false,
      total: 20, //表格总数
      totalSelect: 20, //表格总数
      // total: 0, //表格总数
      detailDialogVisible: false,
      selectRow: [],
      report_cycle: "",
      passDialogVisible: false,
      showDialogVisible: false,
    };
  },
  methods: {
    handleClick() {
      if (this.activeName !== "reportClassify") {
        this.$router.push("/index/workbench/" + this.activeName);
      }
    },
    getdata() {
      this.loading = true;
      this.tableData = [];
      const param = {};
      if (this.formInline.region !== "") {
        param["region"] = this.formInline.region;
      }
      if (this.formInline.date_range !== "") {
        param["date_range"] = this.formInline.date_range;
      }
      if (this.formInline.report_cycle !== "") {
        param["report_cycle"] = this.formInline.report_cycle;
      }
      this.tableDate = this.$moment(this.formInline.date_range).format(
        "YYYY年MM月"
      );
      this.region = this.formInline.region;
      this.date_range = this.formInline.date_range;
      this.$axios
        .post("/business/insertMonitor/toNameStatistics", param)
        .then((res) => {
          res.data.forEach((temp) => {
            temp.obj = temp.code === "003" ? "园区" : "企业";
            if (temp.report_cycle == 0) {
              temp.cycle = "月报";
            } else if (temp.report_cycle == 1) {
              temp.cycle = "季报";
            } else if (temp.report_cycle == 2) {
              temp.cycle = "半年报";
            } else if (temp.report_cycle == 3) {
              temp.cycle = "年报";
            }
          });
          this.tableData = res.data;
          this.loading = false;
        });
    },
    toDetail(row, name) {
      this.report_cycle = row.code;
      this.activeNames = name;
      this.showDialogVisible = true;
    },
    onSubmit() {
      this.getdata();
    },
    reset() {
      this.formInline = {
        //查询对象
        report_cycle: "0",
        date_range: this.$moment(new Date()).format("YYYY-MM"),
        region: "",
      };
      this.getdata(1);
    },
    getRegionTree() {
      this.regionTree = [];
      this.$axios.get("/business/dm/dq/tree").then((res) => {
        res.data.forEach((temp) => {
          if (temp.parent_code == "-1") {
            this.regionTree.push(temp);
          }
        });
      });
    },
    exportData() {
      let column = [
        {
          title: "报表名称",
          key: "name",
        },
        {
          title: "报表周期",
          key: "cycle",
        },
        {
          title: "填报对象",
          key: "obj",
        },
        {
          title: "应填表数",
          key: "count",
        },
        {
          title: "已上报数",
          key: "ysbCount",
        },
        {
          title: "未上报数",
          key: "wsbCount",
        },
        {
          title: "未审核数",
          key: "wshCount",
        },
        {
          title: "审核未通过数",
          key: "shbtgCount",
        },
        {
          title: "审核通过数",
          key: "shtgCount",
        },
      ];
      export2Excel(
        column,
        this.tableData,
        `${this.tableDate}《${this.tableForm}》报送情况`
      );
    },
  },
  created() {
    this.reset();
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}
@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
}
.industryCode {
  box-shadow: 0px 0px 50px #ccc;
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .industryCode_header {
    height: 31px;
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    .industryCode_logo {
      margin: 2px 20px 0 2px;
    }
    h3 {
      font-size: 24px;
      height: 100%;
      margin: 0;
      color: #444444;
    }
  }
  .industryCode_form {
    height: 70px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(155, 155, 155, 0.25);
    margin-bottom: 20px;
    .el-form {
      .el-form-item {
        margin-right: 30px;
      }
    }
  }
  .industryCode_add_user {
    margin-bottom: 20px;
  }
  .el-dialog {
    .addUser {
      .el-form-item {
        .el-select {
          width: 100%;
        }
      }
    }
  }
}
.detail {
  width: 100%;
  height: 100%;
  cursor: pointer;
  color: #5584ff;
}
</style>